import React from "react";
import Select from "react-select";

export default function ChipsField({ field, value, onChange }) {
  const opts = field.options || [];
  const selected = opts.filter(o => (value || []).includes(o.value));
  return (
    <div className="mp-form-group">
      <label className="mp-form-label">{field._label}</label>
      <Select
        isMulti
        className="mp-select"
        options={opts}
        value={selected}
        onChange={list => onChange(field.name, (list || []).map(o => o.value))}
      />
    </div>
  );
}
